// Module
var code = "<student-comparison-graph stats=\"row.stats\"></student-comparison-graph>\n";
// Exports
module.exports = code;